/* eslint-disable */
import countryList from '@/data/country.js';
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters([
      'get_pallet_options',
    ]),
    rowData() {
      const objArray = [];
      for (let ii = 1; ii < 20; ii++) {
        objArray.push({
          text: ii.toString(),
          value: ii,
        });
      }
      return objArray;
    },
    numbers() {
      const objArray = [];
      for (let ii = 1; ii < 20; ii++) {
        objArray.push({
          text: ii.toString(),
          value: ii,
        });
      }
      return objArray;
    },
    unitsDimensionSelection() {
      return [
        {text: 'm', value: 'm'},
        {text: 'cm', value: 'cm'},
        {text: 'mm', value: 'mm'},
        {text: 'in', value: 'in'},
        {text: 'ft', value: 'ft'},
      ];
    },
    unitsWeightSelection() {
      return [
        {text: 'kg', value: 'kg'},
        {text: 'gr', value: 'g'},
        {text: 'lb', value: 'lb'},
      ];
    },
    dgUnitsWeightSelection() {
      return [
        {text: 'kg', value: 'kg'},
        {text: 'liter', value: 'liter'},
      ];
    },
    nemWeightSelection() {
      return [
        {text: 'kg', value: 'kg'},
      ];
    },
    palleteTypesSelection() {
      return this.get_pallet_options;
    },
    goodsTypeSelection() {
      return [
        {text: 'parcel', value: '1'},
        {text: 'document', value: '2'},
        {text: 'pallet', value: '3'},
        {text: 'load', value: '4'}
      ]
    },
    getIncotermOptions() {
      return [
        { text: `${this.$t('DAP')}`, value: 'DAP'},
        { text: `${this.$t('DDP')}`, value: 'DDP'},
        { text: `${this.$t('EXW')}`, value: 'EXW'},
        { text: `${this.$t('FCA')}`, value: 'FCA'},
        { text: `${this.$t('CPT')}`, value: 'CPT'},
        { text: `${this.$t('CIP')}`, value: 'CIP'},
        { text: `${this.$t('DPU')}`, value: 'DPU'},
      ];
    }
  },
  methods: {
    getCountry: (country_id, prop, fromCALL) => {
      // console.log(`GET "${prop}" of country ${country_id || 'undefined'} and ${fromCALL || 'NOT CALLED FROM REGISTERED CALL'}`)
      return countryList.filter((opt) => opt.id === String(country_id))[0][`${prop}`];
    },
    getVolumeText(volDm3) {
      if (!volDm3) {
        return `0.00 dm`;
      }

      return volDm3 > 10 ? `${parseFloat(volDm3 / 1000).toFixed(2)} m` : `${parseFloat(volDm3).toFixed(2)} dm`
    }
  },
}
